<template>
  <div class="_404">
    <h2 class="m-0">抱歉，页面未找到，<span>{{countDown}}</span>s后自动跳转到
      <a href="javascript:;" @click="goBack">上一页</a>
    </h2>
    <img src="./images/404.png" alt="页面未找到">
  </div>
</template>

<script>
export default {
  name: "NF404",
  data() {
    return {
      countDown: 5,
      timer: null
    }
  },
  methods: {
    // 优化跳转逻辑：优先返回上一页，无历史记录则跳首页
    goBack() {
      // 清除倒计时定时器
      clearInterval(this.timer);
      
      // 判断是否有上一页历史记录
      if (window.history.length > 1) {
        // 方式1：返回上一页（推荐）
        this.$router.go(-1);
        // 方式2：也可以用 window.history.back()，效果一致
        // window.history.back();
      } else {
        // 无历史记录时降级跳首页
        this.$router.push('/');
      }
    }
  },
  created() {
    // 倒计时自动跳转逻辑
    this.timer = setInterval(() => {
      if (this.countDown > 0) {
        this.countDown--;
      } else {
        // 倒计时结束调用统一的跳转方法
        this.goBack();
      }
    }, 1000);
  },
  // 组件销毁时清除定时器，避免内存泄漏
  beforeUnmount() {
    clearInterval(this.timer);
  }
}
</script>

<style scoped>
._404 {
  width: 30%;
  margin: 0 auto;
  padding-top: 10rem;
}

._404 img {
  width: 30rem;
}

._404 a {
  color: #010101;
}

._404 a:hover {
  color: #7dbcf7;
}
</style>